import * as React from 'react';

import styles from './HowItWorks.css';

export const HowItWorks: React.FC<React.PropsWithChildren> = (props: React.PropsWithChildren) => {
  return (
    <div className={styles['how-it-works']}>
      <h2 className={styles['title']}>Как&nbsp;всё&nbsp;работает</h2>

      <div className={styles['container']}>
        {React.Children.map(props.children, (child: React.ReactNode, index: number) => (
          <div className={styles['item']} key={index}>
            {child}
          </div>
        ))}
      </div>
    </div>
  );
};
